/* istanbul ignore file */
import { createUseStyles } from '@glu/theming';

export default createUseStyles(({ nav: { horiz } }) => ({
  custom: {
    position: 'normal'
  },
  root: {
    position: 'absolute',
    background: horiz.dropdown.backgroundColor,
    left: 0,
    top: horiz.tier0.linkHeight + horiz.borderBottomWidth,
    width: '100%',
    boxShadow: horiz.dropdown.boxShadow,
    display: 'flex',
    listStyleType: 'none',
    margin: 0,
    alignItems: 'stretch',
    padding: [28, 0],
    '& ul': {
      margin: [0, 0, 20, 0],
      padding: 0,
      listStyleType: 'none'
    },
    '& > li': {
      borderLeft: `1px solid ${horiz.dropdown.borderColor}`,
      padding: [0, 18],
      '&:first-child': {
        border: 0
      }
    },
    '& h3': {
      fontWeight: 'bold',
      fontFamily: horiz.fontFamily,
      color: horiz.textColor,
      fontSize: 18,
      lineHeight: '22px',
      margin: [0, 0, 10, 0],
      padding: 0
    },
    '& a': {
      fontWeight: 'normal',
      fontFamily: horiz.fontFamily,
      fontSize: 18,
      lineHeight: '22px',
      margin: [0, 0, 10, 0],
      display: 'block',
      padding: 0,
      color: horiz.linkColor,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  }

}));
